import { BadgeCheck, Wrench, CalendarClock, Percent } from "lucide-react";
import { MEMBER_BENEFITS, COMPLIMENTARY_SERVICES, EXCLUSIONS_NOTE } from "../../data/membership";

export const BenefitsSection = () => (
  <section className="py-16 border-y border-zinc-800/60 bg-[#0d0d0d]" data-testid="membership-benefits">
    <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-12">
      <div>
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-blue-500">Member Benefits</span>
        <h2 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-white mt-4 mb-6">
          Everything Your Vehicle Needs, Covered Monthly
        </h2>
        <ul className="space-y-3">
          {MEMBER_BENEFITS.map((b) => (
            <li key={b} className="flex items-start gap-3 text-zinc-300">
              <BadgeCheck className="h-5 w-5 text-blue-500 shrink-0 mt-0.5" />
              <span>{b}</span>
            </li>
          ))}
        </ul>
        <p className="text-zinc-500 text-xs leading-relaxed mt-8 border border-zinc-800 rounded-sm p-4" data-testid="exclusions-note">
          {EXCLUSIONS_NOTE}
        </p>
      </div>
      <div className="bg-[#121212] border border-zinc-800 rounded-xl p-8">
        <div className="flex items-center gap-3 mb-5">
          <div className="h-11 w-11 rounded-sm bg-blue-500/10 border border-blue-500/30 flex items-center justify-center">
            <Wrench className="h-5 w-5 text-blue-500" />
          </div>
          <h3 className="font-heading text-lg font-semibold text-white">
            Your Complimentary Annual Service — Choose ONE
          </h3>
        </div>
        <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-2.5">
          {COMPLIMENTARY_SERVICES.map((s) => (
            <li key={s} className="flex items-start gap-2 text-sm text-zinc-300">
              <span className="text-blue-500 mt-1">•</span> {s}
            </li>
          ))}
        </ul>
        <div className="grid grid-cols-2 gap-4 mt-8">
          <div className="border border-zinc-800 rounded-sm p-4 text-center">
            <Percent className="h-5 w-5 text-blue-500 mx-auto mb-2" />
            <div className="font-heading font-bold text-white">10% Off</div>
            <div className="text-zinc-500 text-xs">Eligible Labor</div>
          </div>
          <div className="border border-zinc-800 rounded-sm p-4 text-center">
            <CalendarClock className="h-5 w-5 text-blue-500 mx-auto mb-2" />
            <div className="font-heading font-bold text-white">Priority</div>
            <div className="text-zinc-500 text-xs">Scheduling</div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
